import { render } from "./Index.vue?vue&type=template&id=c0c82f10&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c0c82f10&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=c0c82f10&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c82f10"]])

export default __exports__